module.exports = "/lucky-balls/video/bonus_yellow.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/video/bonus_yellow.mp4
// module id = 893
// module chunks = 0